var render = function () {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._g(
      _vm._b(
        {
          staticClass: "award",
          class: [
            ((_obj = {}), (_obj["rarity_" + _vm.rarity] = _vm.rarity), _obj),
            { locked: _vm.LockType },
            { "checked-border": _vm.is_checked },
          ],
        },
        "div",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    ),
    [
      _vm.rate
        ? _c("span", { staticClass: "rate" }, [_vm._v(_vm._s(_vm.rate) + "%")])
        : _vm._e(),
      _c("div", { staticClass: "goods-img" }, [
        _c("img", { attrs: { src: _vm._f("imgfilter")(_vm.picture) } }),
      ]),
      _c("div", { staticClass: "goods-info-wrap" }, [
        _c(
          "div",
          { staticClass: "goods-price" },
          [
            _vm._v(" " + _vm._s(_vm.price) + " "),
            _c("c-svg", {
              staticClass: "icon",
              attrs: { src: "bill.svg", width: "14" },
            }),
          ],
          1
        ),
        _c("div", { staticClass: "goods-bottom-info" }, [
          _c(
            "span",
            {
              staticClass: "goods-name fl",
              attrs: { title: _vm.name + "(" + _vm.descriptor + ")" },
            },
            [_vm._v(" " + _vm._s(_vm.name) + " ")]
          ),
        ]),
      ]),
      _c("div", { staticClass: "exterior" }, [_vm._v(_vm._s(_vm.descriptor))]),
      _vm.is_checked
        ? _c("div", { staticClass: "checked" }, [
            _c("i", {
              staticClass: "ivu-icon ivu-icon-md-checkmark-circle-outline",
            }),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }